<template>
    <bp-tabs id="tabs-top" class="-shadow" ref="profileTabs" @selected-tab="changeTab()" :tabs="{ tab1: 'Personal<br>Information', tab2: 'Your<br>Preferences', tab3: 'Change Email<br>and Password' }" :gray-tabs="grayTabs">
        <template slot="tab-panel-tab1">
            <form  id="user-info-form" class="form" method="post" accept-charset="UTF-8" @submit.prevent="updateAccount('step-1')" data-vv-scope="step-1" enctype="multipart/form-data">
                <input type="hidden" name="userId" v-model="user.userId">
                <div class="tabs__intro">
                    <p class="tabs__introCopy">
                        Thank you for keeping your personal information up to date, as this data is used throughout the portal and community for registration and communications.
                    </p>
                    <div class="fact -inline -dark">
                        <span class="meta -fact fact__meta">Last Updated</span> <span class="fact__stat">{{ user.dateUpdated }}</span>
                    </div>
                </div>
                <div class="tab1" v-if="successMessage1">
                    <p class="messaging -success -subtle" v-text="successMessage1"></p>
                </div>
                <div class="tab1" v-if="errorMessage1">
                    <p class="messaging -error -subtle" v-text="errorMessage"></p>
                </div>
                <fieldset>
                    <label class="note"><span class="required">*</span> Indicates required field</label>
                    <div class="grid -col3 -form">
                       <div class="grid__cell">
                            <div class="text">
                                <label for="firstName">First Name <span class="required">*</span></label>
                                <input
                                    data-vv-as="First Name"
                                    aria-label="First Name"
                                    title="First Name" 
                                    v-model="user.firstName"
                                    v-validate.disable="rules['firstName']"
                                    type="text"
                                    name="firstName"
                                    placeholder=""
                                    @input="infoChanged('step-1')"
                                                            />
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.firstName')"
                                v-text="errors.first('step-1.firstName')"
                            ></p>
                        </div>
                        <div class="grid__cell">
                            <div class="text">
                                <label for="lastName">Last Name <span class="required">*</span></label>
                                <input
                                    data-vv-as="Last Name"
                                    aria-label="Last Name"
                                    title="Last Name"
                                    v-model="user.lastName"
                                    v-validate.disable="rules['lastName']"
                                    type="text"
                                    name="lastName"
                                    placeholder=""
                                    @input="infoChanged('step-1')"
                                                            />
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.lastName')"
                                v-text="errors.first('step-1.lastName')"
                            ></p>
                        </div>
                        <div class="grid__cell">
                            <div class="text">
                                <label for="nickname">Nickname</label>
                                <input
                                    data-vv-as="Nickname"
                                    aria-label="Nickname"
                                    title="Nickname"
                                    v-model="user.nickname"
                                    v-validate.disable="rules['nickname']"
                                    type="text"
                                    name="nickname"
                                    placeholder=""
                                    @input="infoChanged('step-1')"
                                                            />
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.nickname')"
                                v-text="errors.first('step-1.nickname')"
                            ></p>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="grid -col3 -form">
                        <div class="grid__cell">
                            <div class="text">
                                <label for="firmName">Account Name / Firm</label>
                                 <input disabled
                                    data-vv-as="Firm"
                                    aria-label="Firm"
                                    title="Firm"
                                    v-model="user.firm"
                                    type="text"
                                    name="firm"
                                    placeholder=""
                                    @input="infoChanged('step-1')"
                                />
                            </div>
                        </div>
                        <div class="grid__cell">
                            <div class="text">
                                <label for="department">Department</label>
                                <input
                                    data-vv-as="Department"
                                    aria-label="Department"
                                    title="Department"
                                    v-model="user.department"
                                    type="text"
                                    name="department"
                                    v-validate.disable="rules['department']"
                                    @input="infoChanged('step-1')"
                                />
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.department')"
                                v-text="errors.first('step-1.department')"
                            ></p>
                        </div>
                        <div class="grid__cell">
                            <div class="text">
                                <label for="jobTitle">Job Title / Position <span class="required">*</span></label>
                                <input
                                    data-vv-as="Job Title"
                                    aria-label="Job Title"
                                    title="Job Title"
                                    v-model="user.jobTitle"
                                    type="text"
                                    name="jobTitle"
                                    v-validate.disable="rules['jobTitle']"
                                    @input="infoChanged('step-1')"
                                />
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.jobTitle')"
                                v-text="errors.first('step-1.jobTitle')"
                            ></p>
                        </div>
                    </div>
                    <div class="grid -col3 -form">
                        <!--<div class="grid__cell">
                            <input type="hidden" v-model="fullEmail" name="fullEmail" v-validate.disable="rules['fullEmail']" data-vv-as="Corporte Email" >
                            <label for="email">Corporate Email <span class="required">*</span></label>
                            <div class="inputGroup -tagged -reverse">
                                <input
                                    data-vv-as="Email"
                                    aria-label="Email"
                                    v-model="emailName"
                                    title="Email"
                                    type="text"
                                    v-validate.disable="rules['emailName']"
                                    name="email"
                                    class="inputGroup__input"
                                    @input="updateFullEmail"
                                    
                                />
                                <span class="inputGroup__tag" v-text="emailDomain"></span>
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.fullEmail')"
                                v-text="errors.first('step-1.fullEmail')"
                            ></p>
                        </div>-->
                        <div class="grid__cell">
                            <div class="text">
                                <label for="email">Phone Number <span class="required">*</span></label>
                                <input
                                    data-vv-as="Phone"
                                    aria-label="Phone"
                                    title="Phone"
                                    v-model="user.phone"
                                    type="text"
                                    name="phone"
                                    placeholder=""
                                    v-validate.disable="rules['phone']"
                                    @input="infoChanged('step-1')"
                                />
                            </div>
                            <p
                                class="messaging -error -subtle"
                                v-show="errors.has('step-1.phone')"
                                v-text="errors.first('step-1.phone')"
                            ></p>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div>
                        <div class="grid -form">
                            <div class="grid__cell">
                                <div class="text">
                                    <label for="officeAddress1">Office Address <span class="required">*</span></label>
                                    <input
                                        data-vv-as="Office Address"
                                        aria-label="Office Address"
                                        title="Office Address"
                                        v-model="user.address1"
                                        type="text"
                                        name="address1"
                                        v-validate.disable="rules['address1']"
                                        @input="infoChanged('step-1')"
                                    />
                                    <input
                                        type="text"
                                        name="address2"
                                        data-vv-as="Address Line 2"
                                        aria-label="Address Line 2"
                                        title="Address Line 2"
                                        v-model="user.address2"
                                        @input="infoChanged('step-1')"
                                    />
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-1.address1')"
                                    v-text="errors.first('step-1.address1')"
                                ></p>
                            </div>
                        </div>
                        <div class="grid -col3 -form">
                            <div class="grid__cell">
                                <div class="text">
                                    <label for="city">City <span class="required">*</span></label>
                                    <input
                                        data-vv-as="City"
                                        aria-label="City"
                                        title="City"
                                        v-model="user.city"
                                        type="text"
                                        name="city"
                                        v-validate.disable="rules['city']"
                                        @input="infoChanged('step-1')"
                                    />
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-1.city')"
                                    v-text="errors.first('step-1.city')"
                                ></p>
                            </div>
                            <div class="grid__cell">
                                <div class="select">
                                    <label for="state">State / Province / Region</label>
                                    <div v-if="currentCountry=='United States'">
                                        <v-select
                                            data-vv-as="State"
                                            class="select__options"
                                            v-model="user.state"
                                            name="state"
                                            title="State"
                                            :transition="null"
                                            :options="stateOptions"
                                            @input="infoChanged('step-1')"
                                        ></v-select>
                                    </div>
                                    <div v-else-if="currentCountry=='Canada'">
                                        <v-select
                                            data-vv-as="CA Province"
                                            class="select__options"
                                            v-model="user.state"
                                            name="caProvince"
                                            title="caProvince"
                                            :transition="null"
                                            :options="caProvinceOptions"
                                            @input="infoChanged('step-1')"
                                        ></v-select>
                                    </div>
                                    <div v-else-if="currentCountry=='China'">
                                        <v-select
                                            data-vv-as="China Province"
                                            class="select__options"
                                            v-model="user.state"
                                            name="cnProvince"
                                            title="cnProvince"
                                            :transition="null"
                                            :options="cnProvinceOptions"
                                            @input="infoChanged('step-1')"
                                        ></v-select>
                                    </div>
                                    <div v-else-if="currentCountry=='Ireland'">
                                        <v-select
                                            data-vv-as="Ireland Province"
                                            class="select__options"
                                            v-model="user.state"
                                            name="ieProvince"
                                            title="ieProvince"
                                            :transition="null"
                                            :options="ieProvinceOptions"
                                            @input="infoChanged('step-1')"
                                        ></v-select>
                                    </div>
                                    <div v-else-if="currentCountry=='Australia'">
                                        <v-select
                                            data-vv-as="Aus Province"
                                            class="select__options"
                                            v-model="user.state"
                                            name="auProvince"
                                            title="auProvince"
                                            :transition="null"
                                            :options="auProvinceOptions"
                                            @input="infoChanged('step-1')"
                                        ></v-select>
                                    </div>
                                    <div v-else-if="currentCountry=='India'">
                                        <v-select
                                            data-vv-as="India Province"
                                            class="select__options"
                                            v-model="user.state"
                                            name="inProvince"
                                            title="inProvince"
                                            :transition="null"
                                            :options="inProvinceOptions"
                                            @input="infoChanged('step-1')"
                                        ></v-select>
                                    </div>
                                    <div v-else><input type="text" v-model="user.stateText"></div>
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-1.state')"
                                    v-text="errors.first('step-1.state')"
                                ></p>
                            </div>
                            <div class="grid__cell">
                                <div class="text">
                                    <label for="zip">Postal Code <span class="required">*</span></label>
                                    <input
                                        data-vv-as="Postal Code"
                                        aria-label="Postal Code"
                                        title="Postal Code"
                                        v-model="user.zip"
                                        type="text"
                                        name="zip"
                                        v-validate.disable="rules['zip']"
                                        @input="infoChanged('step-1')"
                                    />
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-1.zip')"
                                    v-text="errors.first('step-1.zip')"
                                ></p>
                            </div>
                        </div>
                        <div class="grid -col2 -form">
                            <div class="grid__cell">
                                <div class="select">
                                    <label for="country">Country<span class="required">*</span></label>
                                    <v-select
                                        data-vv-as="Country"
                                        class="select__options"
                                        v-model="user.country"
                                        name="country"
                                        title="Country"
                                        :transition="null"
                                        :options="countryOptions"
                                        @input="changeState"
                                        v-validate:user.country="rules['country']"
                                        :clearable="false"
                                    ></v-select>
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-if="hasCountryError"
                                    v-text="countryError"
                                ></p>
                            </div>
                            <div class="grid__cell">
                                <div class="select">
                                    <label for="timezone">Time zone <span class="required">*</span></label>
                                    <v-select
                                        class="select__options"
                                        data-vv-as="Time zone"
                                        v-model="user.timezone"
                                        name="timezone"
                                        title="Timezone"
                                        :transition="null"
                                        :options="timezoneOptions"
                                        @input="hasTimezoneError = false;infoChanged('step-1')"
                                        v-validate:user.timezone="rules['timezone']"
                                        :clearable="false"
                                    ></v-select>
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-if="hasTimezoneError"
                                    v-text="timezoneError"
                                ></p>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="grid -form">
                        <div class="grid__cell text">
                            <label for="">Social Media Links</label>
                            <div class="inputGroup -tagged">
                                <input 
                                    class="inputGroup__input" 
                                    type="text" 
                                    id="twitter" 
                                    name="twitter"
                                    data-vv-as="Twitter"
                                    aria-label="Twitter"
                                    v-validate.disable="rules['twitter']"
                                    v-model="user.twitter" 
                                    @input="infoChanged('step-1')"
                                >
                                <span class="inputGroup__tag">
                                    <svg class="symbol inputGroup__icon">
                                        <use xlink:href="#twitter" />
                                    </svg>
                                    https://twitter.com/
                                </span>
                            </div>
                            <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-1.twitter')"
                                    v-text="errors.first('step-1.twitter')"
                                ></p>
                            <div class="inputGroup -tagged">
                                <input 
                                    class="inputGroup__input" 
                                    type="text" 
                                    id="linkedin" 
                                    name="linkedin"
                                    data-vv-as="LinkedIn"
                                    aria-label="LinkedIn"
                                    v-validate.disable="rules['linkedin']"
                                    v-model="user.linkedin"
                                    @input="infoChanged('step-1')"
                                >
                                <span class="inputGroup__tag">
                                    <svg class="symbol inputGroup__icon">
                                        <use xlink:href="#linkedin" />
                                    </svg>
                                    https://linkedin.com/in/
                                </span>
                            </div>
                             <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-1.linkedin')"
                                    v-text="errors.first('step-1.linkedin')"
                                ></p>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="grid -form">
                        <div class="grid__cell">
                            <label for="file">Profile Image</label>
                            <div id="user-photo" class="custom-file-container fileUpload">
                                <div v-if="user.userPhoto" class="custom-file-container__image-preview fileUpload__preview" :style="{ backgroundImage: 'url(' + user.userPhoto + ')' }">
                                    <!-- <img :class="fileUpload__thumbnail" :src="user.userPhoto"> -->
                                </div>
                                <label class="inputGroup__hidden">Profile Image <a href="javascript:void(0)" class="custom-file-container__image-clear fileUpload__clear" title="Clear Image">&times;</a></label>
                                <label class="custom-file-container__custom-file inputGroup">
                                    <input type="file" @change="onFileChange" accept="image/png,image/jpeg" aria-label="Choose File" class="custom-file-container__custom-file__custom-file-input inputGroup__input"/>
                                    <span class="custom-file-container__custom-file__custom-file-control">
                                        {{ user.userPhoto.indexOf("blob:") >= 0 ? user.photoFile.name : (user.userPhoto.lastIndexOf("/") ? user.userPhoto.slice(user.userPhoto.lastIndexOf("/") + 1) : "") }}
                                        <span class="custom-file-container__custom-file__custom-file-control__button"> Change Image</span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="grid__cell"></div>
                    </div>
                </fieldset>
                <div class="form__actions">
                    <button class="button -cta" type="submit">Save Information</button>
                </div>
            </form>
        </template>
        <template slot="tab-panel-tab2">
            <div class="tabs__intro">
                <p class="tabs__introCopy">
                    By selecting topics below, you can customize the events and insights that will be highlighted in your dashboard.
                </p>
                <div class="fact -inline -dark">
                    <span class="meta -fact fact__meta">Last Updated</span> <span class="fact__stat">{{ user.dateUpdated }}</span>
                </div>
            </div>
            <div class="tab1" v-if="successMessage2">
                <p class="messaging -success -subtle" v-text="successMessage2"></p>
            </div>
            <div class="tab1" v-if="errorMessage2">
                <p class="messaging -error -subtle" v-text="errorMessage"></p>
            </div>
            <form class="form" method="post" accept-charset="UTF-8" @submit.prevent="updateAccount('step-2')" data-vv-scope="step-2" >
                <input type="hidden" name="userId" v-model="user.userId">

                <div v-if="allInterestsOption">
                    <div class="grid -third -form">
                        <div class="grid__cell">
                            <input
                                class="radio__input"
                                id="all-topics"
                                type="radio"
                                name="allInterests"
                                value="true"
                                :checked="allInterestsSelected"
                                @click="allInterests"
                            />
                            <label for="all-topics" class="radio__label">
                                <h4>All Topics</h4>
                            </label>
                        </div>
                    </div>
                </div>

                <div v-for="children, parent in interests" :key="children.value">
                    <div class="grid -third -form">
                        <div class="grid__cell">
                            <input
                                class="checkbox__input"
                                type="checkbox"
                                name="interests"
                                v-model="user.interests"
                                :value="children.value"
                                :id="children.value"
                                @change="updateInterests(children)"
                            />
                            <label :for="children.value" class="checkbox__label">
                                <h4>{{ parent }}</h4>
                            </label>
                        </div>
                        <div class="grid__cell">
                            {{ children.description }}
                        </div>
                    </div>
                </div>

                <hr />

                <div v-if="loaded">
                    <div class="grid -third -form">
                        <div class="grid__cell">
                            <input
                                class="radio__input"
                                type="radio"
                                name="all-events"
                                value="1"
                                id="all-events"
                                :checked="allEventsSelected"
                                @click="allEvents"
                            />
                            <label for="all-events" class="radio__label">
                                <h4>
                                    All Events
                                </h4>
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="loaded">
                    <div class="grid -third -form">
                        <div class="grid__cell">
                            <input
                                class="checkbox__input"
                                type="checkbox"
                                name="in-person"
                                v-model="user.eventsInPerson"
                                value="1"
                                id="in-person"
                                @change="allEventsCheck"
                            />
                            <label for="in-person" class="checkbox__label">
                                <h4>
                                    In Person
                                </h4>
                            </label>
                        </div>
                        <div class="grid__cell">
                            Focus roundtables, regional day events
                        </div>
                    </div>
                </div>
                <div v-if="loaded">
                    <div class="grid -third -form">
                        <div class="grid__cell">
                            <input
                                class="checkbox__input"
                                type="checkbox"
                                name="virtual"
                                v-model="user.eventsVirtual"
                                value="1"
                                id="virtual"
                                @change="allEventsCheck"
                            />
                            <label for="virtual" class="checkbox__label">
                                <h4>
                                    Virtual
                                </h4>
                            </label>
                        </div>
                        <div class="grid__cell">
                            CutterCast webinars, Vendor Views, Virtual roundtables
                        </div>
                    </div>
                </div>

                <div class="form__actions">
                    <button class="button -cta" type="submit">Update My Prferences</button>
                </div>
            </form>
        </template>
        <template slot="tab-panel-tab3">
            <div class="tabs__intro">
                <h3>Change Your Email and Password</h3>
            </div>
            <div class="tab1" v-if="successMessage3">
                <p class="messaging -success -subtle" v-text="successMessage3"></p>
            </div>
            <div class="tab1" v-if="errorMessage3">
                <p class="messaging -error -subtle" v-text="errorMessage"></p>
            </div>
            <form id="password-reset-form" class="form" action="" method="post"  @submit.prevent="updateAccount('step-3')" data-vv-scope="step-3" >
                <fieldset>
                    <label class="note"><span class="required">*</span> Indicates required field</label>                               
                    
                    <div class="grid -thirdReverse -form">
                        <div class="grid_cell">
                            <input type="hidden" v-model="fullEmail" name="fullEmail" v-validate="rules['fullEmail']" data-vv-as="Corporte Email" >
                                <label for="email">Corporate Email <span class="required">*</span></label>
                                <div class="inputGroup -tagged -reverse">
                                    <input
                                        data-vv-as="Email"
                                        aria-label="Email"
                                        v-model="emailName"
                                        title="Email"
                                        type="text"
                                        v-validate.disable="rules['emailName']"
                                        name="email"
                                        class="inputGroup__input"
                                        @input="infoChanged('step-3')"
                                        @change="updateFullEmail"
                                        
                                    />
                                    <span class="inputGroup__tag" v-text="emailDomain"></span>
                                </div>
                                <p
                                    class="messaging -error -subtle"
                                    v-show="errors.has('step-3.fullEmail')"
                                    v-text="errors.first('step-3.fullEmail')"
                                ></p>
                            </div>
                    </div>
                    <div class="text -auto">
                        <label for="password">Current Password <span class="required">*</span></label>
                        <input
                            data-vv-delay="5000"
                            data-vv-as="Password"
                            v-validate.disable="rules['password']"
                            v-model="password"
                            type="password"
                            name="password"
                            title="Password"
                            id="password"
                            @input="infoChanged('step-3')"
                        />
                        <p
                            class="messaging -error -subtle"
                            v-show="errors.has('step-3.password')"
                            v-text="errors.first('step-3.password')"
                        ></p>
                    </div>
                    <div class="text -auto">
                        <label for="passwordNew">New Password</label>
                        <input
                            data-vv-delay="5000"
                            data-vv-as="New Password"
                            v-validate.disable="rules['new_password']"
                            v-model="new_password"
                            type="password"
                            name="new_password"
                            title="New Password"
                            @input="infoChanged('step-3')"
                        />
                        <p
                            class="messaging -error -subtle"
                            v-show="errors.has('step-3.new_password')"
                            v-text="errors.first('step-3.new_password')"
                        ></p>
                    </div>
                    <div class="text -auto">
                        <label for="passwordConfirm">Confirm New Password</label>
                        <input
                            data-vv-delay="2000"
                            data-vv-as="Password Confirmation"
                            v-validate.disable="rules['password_confirmation']"
                            v-model="password_confirmation"
                            type="password"
                            name="password_confirmation"
                            title="Password Confirmation"
                            @keypress="infoChanged('step-3')"
                        />
                        <p
                            class="messaging -error -subtle"
                            v-show="errors.has('step-3.password_confirmation')"
                            v-text="errors.first('step-3.password_confirmation')"
                        ></p>
                    </div>
                    <div class="form__actions">
                        <button class="button -cta">Update Information</button>
                    </div>
                </fieldset> 
            </form>
        </template>
    </bp-tabs>
</template>

<script>
import locationData from "./location-data.js";
import BpTabs from "./BpTabs";
import { Validator } from "vee-validate";
import axios from "axios";
import VueScrollTo from "vue-scrollto";
import { stringify } from 'qs';
import VueSanitize from "vue-sanitize";
import moment from "moment-timezone";

export default {
    components: {
        "bp-tabs": BpTabs,
        moment: moment,
    },
    data() {
        return {
            scope: "step-1",
            error: "",
            user: {
                userId: null,
                email: null,
                firstName: null,
                lastName: null,
                nickname: null,
                firm: null,
                phone: null,
                department: null,
                jobTitle: null,
                address1: null,
                address2: null,
                city: null,
                state: null,
                stateText: null,
                oldState: null,
                zip: null,
                country: null,
                oldCountry: null,
                timezone: null,
                linkedin: null,
                twitter: null,
                userPhoto: "",
                photoFile: null,
                interests: null,
                dateUpdated: null,
                parentInterests: false,
                eventsInPerson: false,
                eventsVirtual: false,
            },
            emailName: null,
            emailDomain: null,
            fullEmail: null,
            currentCountry: null,

            allInterestsOption: false,
            allInterestsSelected: false,
            allEventsSelected: false,

            loaded: false,

            countryError: null,
            hasCountryError: false,

            timezoneError: null,
            hasTimezoneError: false,

            password: null,
            password_confirmation: null,
            new_password: null,

            interests: [],
            successMessage1: null,
            successMessage2: null,
            successMessage3: null,
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,

            currentTab: null,
            grayTabs: [],
            scope1Changed: false,
            scope2Changed: false,
            scope3Changed: false,
            timezoneOptions: [],

        };
    },
    computed: {
        rules() {
            return {
                firstName: {
                    required: true,
                    containsLetter: true,
                    max: 30,
                },
                lastName: {
                    required: true,
                    containsLetter: true,
                    max: 50,
                },
                nickname: {
                    containsLetter: true,
                    max: 30,
                },
                emailDomain: {
                    required: true,
                },
                emailName: {
                    required: true,
                    containsLetter: true,
                },
                fullEmail: {
                    availableUsername: true,
                },
                phone: {
                    required: true,
                    regex: /[\d().+-]/,
                    max: 20,
                },
                department: {
                    containsLetter: true,
                    max: 50,
                },
                jobTitle: {
                    required: true,
                    containsLetter: true,
                    max: 100,
                },
                address1: {
                    required: true,
                },
                city: {
                    required: true,
                    containsLetter: true,
                    max: 50,
                },
                zip: {
                    required: true,
                    max: 20,
                },
                state: {
                    required: true,
                },
                country: {
                    required: true,
                },
                timezone: {
                    required: true,
                },
                password: {
                    required: true,
                    min: 8,
                    max: 64,
                },
                new_password: {
                    //required: true,
                    min: 8,
                    max: 64,
                },
                password_confirmation: {
                    //required: true,
                    confirm: "new_password",
                },
                twitter: {
                    containsLetter: true,
                    regex: /^[A-z_\d]+$/,
                    min: 4,
                    max: 15,
                },
                linkedin: {
                    containsLetter: true,
                    regex: /^[A-z\-\d\/]+$/,
                }
            };
        },

        hasErrors() {
            return this.errors.length > 0 ? true : false;
        },

        countryOptions() {
            return locationData.countries;
        },
        stateOptions() {
            return locationData.states;
        },
        caProvinceOptions() {
            return locationData.provinces;
        },
        auProvinceOptions() {
            return locationData.auRegions;
        },
        cnProvinceOptions() {
            return locationData.cnRegions;
        },
        ieProvinceOptions() {
            return locationData.ieRegions;
        },
        inProvinceOptions() {
            return locationData.inRegions;
        },

        csrf() {
            return {
                //name: window.tokenName,
                value: window.token,
            };
        },

        errorMessage() {
            if (this.error) {
                return this.error
            } else if (this.hasErrors) {
                return "Please correct the invalid fields below."
            }
        },

        
    },
    methods: {
        allEvents() {
            this.allEventsSelected = !this.allEventsSelected;
            this.user.eventsInPerson = this.allEventsSelected;
            this.user.eventsVirtual = this.allEventsSelected;
        },

        allEventsCheck() {
            this.allEventsSelected = (this.user.eventsInPerson && this.user.eventsVirtual);
        },

        allEventsPreselected() {
            this.allEventsSelected = this.user.eventsInPerson && this.user.eventsVirtual;
        },

        allInterests() {
            this.allInterestsSelected = !this.allInterestsSelected;

            this.user.interests = [];

            if (this.allInterestsSelected) {
                for (const index in this.interests) {
                    const interest = this.interests[index];

                    this.user.interests.push(interest.value);
                    interest.children.forEach(value => {
                        this.user.interests.push(value);
                    });
                }
            }
        },

        allInterestsPreselected() {
            let allSelected = true;
            for (const index in this.interests) {
                const interest = this.interests[index];

                if (!this.user.interests.includes(interest.value)) {
                    allSelected = false;
                }
            }

            this.allInterestsSelected = allSelected;
        },

        updateInterests(interests) {
            if (this.user.interests.includes(interests.value)) {
                interests.children.forEach(interest => {
                    if (!this.user.interests.includes(interest)) {
                        this.user.interests.push(interest);
                    }
                });
            } else {
                this.user.interests = this.user.interests.filter(function (ele) {
                    let include = true;
                    interests.children.forEach(interest => {
                        if (ele === interest) {
                            include = false;
                        }
                    });

                    return include;
                });
            }

            this.allInterestsPreselected();
        },

        infoChanged(scope) {
            if (scope == 'step-1') {
                this.scope1Changed = true
                this.grayTabs = ['tab2', 'tab3']
            } else if (scope == 'step-2') {
                this.scope2Changed = true
                this.grayTabs = ['tab1', 'tab3']
            } else {
                this.scope3Changed = true
                this.grayTabs = ['tab1', 'tab2']
            }
        },

        updateFullEmail() {
            this.fullEmail = this.emailName + this.emailDomain
            this.infoChanged('step-3')
        },

        cleanAmp(str) {
            if (str) {
                return str.replaceAll('&amp;', '&')
            } else {
                return ""
            }
        },

        changeState() {
            this.hasCountryError = false;
            this.user.state = "";
            this.user.stateText = "";
            if (this.user.country) {
                if (this.user.country.value == this.user.oldCountry.value) {
                    this.user.state = {"value" : this.user.oldState, "label" : this.getStateFromAbbr(this.user.country.value, this.user.oldState)};
                    this.user.stateText = this.user.oldState;
                }
                this.currentCountry = this.user.country["label"];
            }
            this.infoChanged('step-1');
        },

        firstHalf(children) {
            let length = children.children.length;
            let split = Math.ceil((length/2));
            let first = [];
            for (var i = 0; i < split; i++) {
                first[i] = children.children[i];
            }
            return first;
        },

        lastHalf(children) {
            let length = children.children.length;
            let split = Math.ceil((length/2));
            let last = [];
            for (var i = 0; i < length - split; i++) {
                last[i] = children.children[i + split];
            }
            return last;
        },

        selectWhich(children) {
            if (this.user.interests == null) {
                return;
            }
            var countSelected = 0;
            for (var i = 0; i < children.children.length; i++) {
                if (this.user.interests.includes(children.children[i]["value"])) {
                    countSelected++;
                }
            }
            if (countSelected == children.children.length) {
                return 'Select None';
            } else {
                return 'Select All';
            }
        },

        showDeselect(children) {
            if (this.user.interests == null) {
                return;
            }
            var countSelected = 0;
            for (var i = 0; i < children.children.length; i++) {
                if (this.user.interests.includes(children.children[i]["value"])) {
                    countSelected++;
                }
            }
            if (countSelected == 0) {
                return false;
            } else {
                return true;
            }
        },

        getCountryFromAbbr(abbr) {
            let allCountries = locationData.countries
            var i;
            for (i = 0; i < allCountries.length; i++) {
                if (allCountries[i]['value'] == abbr) {
                    return allCountries[i]['label'];
                }
            }
        },

        getStateFromAbbr(country, abbr) {
            if (abbr == null) {
                return null;
            } else {
                let allStates = [];
                switch(country) {
                    case "CA":
                        allStates = locationData.provinces;
                        break;
                    case "AU":
                        allStates = locationData.auRegions;
                        break;
                    case "CN":
                        allStates = locationData.cnRegions;
                        break;
                    case "IN":
                        allStates = locationData.inRegions;
                        break;
                    case "IE":
                        allStates = locationData.ieRegions;
                        break;
                    case "US":
                        allStates = locationData.states;
                        break;
                }
                for (var i = 0; i < allStates.length; i++) {
                    if (allStates[i]["value"] == abbr) {
                        return allStates[i]["label"];
                    }
                }
                return abbr;
            }

        },

        onFileChange(e) {
            const file = e.target.files[0];
            this.user.userPhoto = URL.createObjectURL(file);
            this.user.photoFile = file;
            this.infoChanged('step-1')
        },

        loadUser() {
            let promises = [];

            promises.push(axios.get("/actions/auth/api/fetch-fields").then((r) => {
                this.interests = r.data.interests;

                if (r.data.interestsCount) {
                    this.allInterestsOption = true;
                }
            }));

            promises.push(axios.get("/actions/auth/api/timezones").then((r) => {
                this.timezoneOptions = r.data;
            }));

            promises.push(axios.get("/actions/auth/api/fetch-user-info").then((r) => {
                this.user.userId = r.data.userId;
                this.user.firstName = this.cleanAmp(r.data.firstName);
                this.user.lastName = this.cleanAmp(r.data.lastName);
                this.user.nickname = this.cleanAmp(r.data.nickname);
                this.user.phone = r.data.phone;
                this.user.email = r.data.email;
                this.user.firm = r.data.acct;
                this.user.department = this.cleanAmp(r.data.department);
                this.user.jobTitle = this.cleanAmp(r.data.jobTitle);
                this.user.address1 = this.cleanAmp(r.data.address1);
                this.user.address2 = this.cleanAmp(r.data.address2);
                this.user.city = r.data.city;
                if (r.data.state) {
                    let stateName = this.getStateFromAbbr(r.data.country, r.data.state);
                    if (stateName == r.data.state) {
                        this.user.stateText = this.cleanAmp(r.data.state);
                    } else {
                        this.user.state = {"value" : r.data.state, "label" : this.getStateFromAbbr(r.data.country, r.data.state)};
                    }
                    this.user.oldState = r.data.state;
                }
                this.user.zip = r.data.zip;
                this.currentCountry = this.getCountryFromAbbr(r.data.country);
                this.user.country = {"value" : r.data.country, "label" : this.getCountryFromAbbr(r.data.country)};
                this.user.oldCountry = this.user.country;
                this.user.timezone = r.data.timezone;
                let tmp = [];
                let i = 0;
                if (r.data.twitter) {
                    this.user.twitter = r.data.twitter.replace("https://twitter.com/", "");
                }
                if (r.data.linkedin) {
                    this.user.linkedin = r.data.linkedin.replace("https://www.linkedin.com/in/", "").replace("https://www.linkedin.com/", "").replace("https://linkedin.com/in/", "").replace("https://linkedin.com/", "");
                }
                this.user.userPhoto = r.data.userPhoto;

                tmp = [];
                i = 0;
                for (var key in r.data.interests) {
                    if (r.data.interests.hasOwnProperty(key)) {
                        tmp[i] = r.data.interests[key]["id"];
                        i++;
                    }
                }
                this.user.interests = tmp;
                this.user.eventsInPerson = r.data.eventsInPerson;
                this.user.eventsVirtual = r.data.eventsVirtual;

                this.user.dateUpdated = r.data.dateUpdated;

                this.fullEmail = r.data.email;

                let temp = r.data.email.split("@");

                this.emailName = temp[0];
                this.emailDomain = "@" + temp[1];

                if (window.location.hash != '#tab2' && window.location.hash != '#tab3') {
                    if (this.user.firstName?.length < 1 || this.user.lastName?.length < 1 || this.user.jobTitle?.length < 1
                        || this.user.phone?.length < 1 || this.user.city?.length < 1 || this.user.zip?.length < 1 ||
                        this.user.country?.value?.length < 1) {
                        this.grayTabs = ['tab2', 'tab3'];
                    } else {
                        this.grayTabs = [];
                    }
                }
            }));

            Promise.all(promises).then(() => {
                this.allEventsPreselected();
                this.allInterestsPreselected();
                this.loaded = true;
            });
        },

        changeTab() {
            if (this.scope1Changed) {
                this.error = "Please save before changing tabs"
                this.errorMessage1 = true
                VueScrollTo.scrollTo("#tabs-top", 1000, { offset: -160 })
                this.grayTabs = ['tab2', 'tab3']
                return false
            } else if (this.scope2Changed) {
                this.error = "Please save before changing tabs"
                this.errorMessage2 = true
                VueScrollTo.scrollTo("#tabs-top", 1000, { offset: -160 })
                this.grayTabs = ['tab1', 'tab3']
                return false
            } else if (this.scope3Changed) {
                this.error = "Please save before changing tabs"
                this.errorMessage3 = true
                VueScrollTo.scrollTo("#tabs-top", 1000, { offset: -160 })
                this.grayTabs = ['tab1', 'tab2']
                return false
            } else {
                this.clearMessages()
                return true
            }
        }, 

        clearMessages() {
            this.successMessage1 = null;
            this.successMessage2 = null;
            this.successMessage3 = null;
            this.error = "";
            this.errorMessage1 = null;
            this.errorMessage2 = null;
            this.errorMessage3 = null;
        },

        updateAccount(scope) {
            var formData = new FormData();
            this.clearMessages()
            let successMessage = "Your information has been updated";
            let validationSuccess = true;
            
            if (scope == "step-1") {
                if (!this.user.country) {
                    validationSuccess = false;
                    this.countryError = "Country is required";
                    this.hasCountryError = true;
                }

                if (!this.user.timezone) {
                    validationSuccess = false;
                    this.timezoneError = "Timezone is required";
                    this.hasTimezoneError = true;
                }
            }

            if (validationSuccess) {
                this.$validator.validateAll(scope).then((result) => {                 
                    // validation failed, return
                    if (result === false) {
                        VueScrollTo.scrollTo("#tabs-top", 1000, { offset: -160 });
                        if (scope == "step-3") {
                            this.errorMessage3 = true
                            this.grayTabs = ['tab1', 'tab2']
                        } else {
                            this.errorMessage1 = true
                            this.grayTabs = ['tab2', 'tab3']
                        }
                        this.error += "Please fix the errors below to continue";
                        return false;
                    } else {
                
                        if (scope == "step-1") {
                            formData.append("firstName", this.$sanitize(this.user.firstName));
                            formData.append('lastName', this.$sanitize(this.user.lastName));
                            formData.append("photo", this.user.photoFile);
                            if (this.user.nickname == null) {
                                formData.append("fields[memberNickname]", "");
                            } else {
                                formData.append("fields[memberNickname]", this.$sanitize(this.user.nickname));
                            }
                            //formData.append("email", this.fullEmail);
                            //formData.append("username", this.fullEmail);
                            formData.append("fields[memberPhoneNumber]", this.user.phone);
                            if (this.user.department == null) {
                                formData.append("fields[memberDepartment]", "");
                            } else {
                                formData.append("fields[memberDepartment]", this.$sanitize(this.user.department));
                            }
                            formData.append("fields[memberTitle]", this.$sanitize(this.user.jobTitle));
                            formData.append("fields[memberAddressLine1]", this.$sanitize(this.user.address1));
                            if (this.user.address2 == null) {
                                formData.append("fields[memberAddressLine2]", "");
                            } else {
                                formData.append("fields[memberAddressLine2]", this.$sanitize(this.user.address2));
                            }
                            
                            formData.append("fields[memberCity]", this.$sanitize(this.user.city));
                            if (this.user.state && this.user.state["value"]) {
                                formData.append("fields[memberState]", this.user.state["value"]);
                                this.user.oldState = this.user.state["value"];
                            } else {
                                if (this.user.stateText == null) {
                                    formData.append("fields[memberState]", "");
                                } else {
                                    formData.append("fields[memberState]", this.$sanitize(this.user.stateText));
                                }
                                this.user.oldState = this.user.stateText;
                            }
                            
                            formData.append("fields[memberZip]", this.user.zip);
                            formData.append("fields[memberCountry]", this.user.country["value"]);
                            this.user.oldCountry = this.user.country; 
                            if (this.user.timezone["value"]) {
                                formData.append("fields[memberTimeZone]", this.user.timezone["value"]);
                            } else {
                                formData.append("fields[memberTimeZone]", this.user.timezone);
                            }
                            if (this.user.twitter == null) {
                                formData.append("fields[personTwitter]", "");
                            } else {
                                formData.append("fields[personTwitter]", this.user.twitter);
                            }
                            if (this.user.linkedin == null) {
                                formData.append("fields[peopleLinkedin]", "");
                            } else {
                                formData.append("fields[peopleLinkedin]", this.user.linkedin);
                            }
                            
                        } else if (scope == "step-2") {
                            if (this.user.interests.length) {
                                for (var i = 0; i < this.user.interests.length; i++) {
                                    formData.append("fields[memberInterests][" + i + "]", this.user.interests[i]);
                                }
                            } else {
                                formData.append("fields[memberInterests][]", null);
                            }

                            formData.append("fields[eventsInPerson]", this.user.eventsInPerson ? "1" : "");
                            formData.append("fields[eventsVirtual]", this.user.eventsVirtual ? "1" : "");
                        } else if (scope == "step-3") {
                            formData.append("password", this.password);
                            formData.append("email", this.fullEmail);
                            //formData.append("username", this.fullEmail);
                            if (this.new_password) {
                                formData.append("newPassword", this.new_password);
                            }
                            
                        }

                        formData.append("userId", this.user.userId);
                        formData.append("CRAFT_CSRF_TOKEN", this.csrf.value);
                        formData.append("action", "users/save-user");

                        axios
                            .post("/", formData, {
                                headers: { "Content-Type": "multipart/form-data",
                                    "x-csrf-token": window.token },
                            })
                            .then((response) => {
                                if (response.data.errors){
                                    for (var key in response.data.errors){
                                        if (scope == "step-1") {
                                            if (response.data.errors[key] != "Incorrect current password.") {
                                                this.error += response.data.errors[key] + "\n";
                                            }
                                        } else {
                                            this.error += response.data.errors[key] + "\n";
                                        }
                                    }
                                } 
                                if (!this.error) {
                                    if (scope == "step-1") {
                                        this.successMessage1 = successMessage;
                                    } else if (scope == "step-2") {
                                        this.successMessage2 = successMessage;
                                    } else if (scope == "step-3") {
                                        this.successMessage3 = successMessage;
                                    }
                                    this.successMessage = "Your information has been updated";
                                } else {
                                    if (scope == "step-1") {
                                        this.errorMessage1 = true;
                                        this.grayTabs = ['tab2', 'tab3']
                                    } else if (scope == "step-2") {
                                        this.errorMessage2 = true;
                                        this.grayTabs = ['tab1', 'tab3']
                                    } else if (scope == "step-3") {
                                        this.errorMessage3 = true;
                                        this.grayTabs = ['tab1', 'tab2']
                                    }
                                }
                                
                                //this.error = "";
                            })
                            .catch((error) => {
                                this.processing = false;
                                if (error.response) {
                                    this.error += error.response.data.error;
                                } else {
                                    this.error +=
                                        "An unknown error occurred - The account was not updated. Please try again.";
                                }
                                console.log(error.response);
                            });
                        if (!this.error) {
                            VueScrollTo.scrollTo("#tabs-top", 1000, { offset: -160 });
                            this.user.dateUpdated = moment().format("MMM D, YYYY");
                        
                            this.scope1Changed = false;
                            this.scope2Changed = false;
                            this.scope3Changed = false;
                            this.grayTabs = []
                        }
                        
                    }
                });
            } else {
                console.log("No validation success")
                VueScrollTo.scrollTo("#tabs-top", 1000, { offset: -160 });
                this.errorMessage1 = true
                this.error += "Please fix the errors below to continue";
                this.grayTabs = ['tab2', 'tab3']
                return false;
            }
        },
    },
    mounted() {
        this.loadUser();
        this.$validator.extend("lettersWithBasicPunc", {
            getMessage: (field) =>
                `The ${field} field must only use letters, dashes, dots, commas, apostrophes, ampersands and parenthesis`,
            validate: (value) => /^[a-z\-\.\',&()\s]+$/i.test(value),
        });

        this.$validator.extend("containsLetter", {
            getMessage: (field) => `The ${field} field must have at least 1 letter`,
            validate: (value) => /[a-z]/i.test(value),
        }); 

        this.$validator.extend("confirm", {
        // custom confirmation rule. vee validates built-in rule was not working.
            getMessage: (field) => `The ${field} does not match`,
            validate: (value, args) => this[args[0]] === value,
        });

        this.$validator.extend("availableUsername", {
            getMessage(field, params, data) {
                return `This email is already taken`;
            },
            validate(value) {
                // this Promise is not compatible with IE11
                return new Promise((resolve) => {
                    axios
                        .get("/actions/auth/api/check-email", {
                            params: { email: value  },
                        })
                        .then((response) => {
                            resolve({
                                valid: !response.data,
                            });
                        });
                    });
            },
        });
    }
}
</script> 
